import { render, staticRenderFns } from "./index.vue?vue&type=template&id=68365a34"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68365a34')) {
      api.createRecord('68365a34', component.options)
    } else {
      api.reload('68365a34', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=68365a34", function () {
      api.rerender('68365a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/setting/index.vue"
export default component.exports